import { c as _c } from "react/compiler-runtime";
import { useLoadMore } from "@website/accommodation-ui/hotel-pagination/hotel-pagination.hook";
import { HotelPaginationPropertiesType } from "@website/accommodation-ui/hotel-pagination/hotel-pagination.types";
import { FC } from "react";
const LoadMore: FC<HotelPaginationPropertiesType> = properties => {
  const $ = _c(2);
  const {
    reference
  } = useLoadMore(properties);
  let t0;
  if ($[0] !== reference) {
    t0 = <div className="flex h-1 w-full justify-center" ref={reference} />;
    $[0] = reference;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const HotelPagination: FC<HotelPaginationPropertiesType> = properties => {
  const $ = _c(6);
  const {
    children,
    loading
  } = properties;
  let t0;
  if ($[0] !== loading || $[1] !== properties) {
    t0 = !loading && <LoadMore {...properties} />;
    $[0] = loading;
    $[1] = properties;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== t0) {
    t1 = <div className="flex w-full flex-col gap-4">{children}{t0}</div>;
    $[3] = children;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};